import moment from 'moment'

const date = () => {
  const prepend = (n) => {
    if (n < 10) {
      return `0${n}`
    } else {
      return `${n}`
    }
  }

  const dates = new Array(31)
  const months = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
  const years = new Array(100)

  const data = {}

  data.dates = []
  for (let i=0; i <= 30; i++) {
    data.dates[i] = i + 1
    data.dates[i] = {value: i+1, key: i, text: prepend(i+1)}
  }

  data.years = []
  let year = 1950
  let count = 0
  // console.log(moment().year())
  while (year < moment().year()) {
    year += 1
    data.years[count] = {value: year, key: count, text: year}
    count ++
  }

  data.months = []
  for (let i=0; i < 12; i++) {
    data.months[i] = {value: i+1, key: i, text: months[i]}
  }
  return data
}

export default date


// WEBPACK FOOTER //
// ./src/lib/date.js